import React from "react";
import { Box, Typography, Paper } from "@mui/material";

const ActivityFrame = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Activity Frame
      </Typography>
      <Paper elevation={2} sx={{ p: 2 }}>
        <Typography>
          This is the ActivityFrame component. Replace this with your actual UI.
        </Typography>
      </Paper>
    </Box>
  );
};

export default ActivityFrame;
